var render = function render(){var _vm=this,_c=_vm._self._c;return _c('com-screen',{attrs:{"id":"app","loading":_vm.loading},scopedSlots:_vm._u([{key:"menu",fn:function(){return [_c('com-menu',[(_vm.window.is.device)?_c('com-foot'):_vm._e()],1)]},proxy:true}])},[_c('router-view',{key:_vm.$keyPath}),(!_vm.window.is.device)?_c('com-foot'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }